<template>
  <div class="page-container-content tabgroup">
    <w-tool-tabs v-model="activeTabName">
      <el-tab-pane :label="tabs.performance.label" :name="tabs.performance.name">
        <div class="full-wrapper">
          <el-scrollbar class="bar-visible">
            <div class="full">
              <w-objtype-bar :active="tabs.performance.active"></w-objtype-bar>
              <w-perf-info-group :active="tabs.performance.active"></w-perf-info-group>
            </div>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="tabs.config.label" :name="tabs.config.name">
        <div class="full-wrapper">
          <el-scrollbar class="bar-visible">
            <div class="full">
              <w-objtype-bar :active="tabs.config.active"></w-objtype-bar>
              <w-config-group :active="tabs.config.active"></w-config-group>
            </div>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="showVcenterLogTab" :label="tabs.vcenterlog.label" :name="tabs.vcenterlog.name">
        <w-vcenterlog-group :active="tabs.vcenterlog.active"></w-vcenterlog-group>
      </el-tab-pane>
      <el-tab-pane v-if="showHypervLogTab" :label="tabs.hypervlog.label" :name="tabs.hypervlog.name">
        <w-hyperv-log-group :active="tabs.hypervlog.active"></w-hyperv-log-group>
      </el-tab-pane>
      <el-tab-pane v-if="showRhevLogTab" :label="tabs.rhevlog.label" :name="tabs.rhevlog.name">
        <w-rhev-log-group :active="tabs.rhevlog.active"></w-rhev-log-group>
      </el-tab-pane>
      <el-tab-pane v-if="showVirtualMapTab" :label="tabs.virtualmap.label" :name="tabs.virtualmap.name">
        <w-virtual-map-frame :active="tabs.virtualmap.active"></w-virtual-map-frame>
      </el-tab-pane>
    </w-tool-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import WVirtualMapFrame from '@/views/performance/components/virtual/VirtualMapFrame';
import WObjtypeBar from '@/views/virtual/performance/group/components/ObjtypeBar';
import RouterTab from '@/mixins/router/tab';
import WPerfInfoGroup from './perfinfo';
import WConfigGroup from './config';
import WVcenterlogGroup from './vcenterlog';
import WHypervLogGroup from './hypervlog';
import WRhevLogGroup from './rhevlog';

export default {
  name: 'WVirtualPerformanceGroup',
  components: {
    WObjtypeBar,
    WPerfInfoGroup,
    WConfigGroup,
    WVcenterlogGroup,
    WVirtualMapFrame,
    WHypervLogGroup,
    WRhevLogGroup,
  },
  mixins: [RouterTab],
  data() {
    return {
      tabs: {
        performance: {
          name: 'performance',
          label: '성능 정보',
          active: false,
          default: true,
        },
        config: {
          name: 'config',
          label: '구성 정보',
          active: false,
        },
        vcenterlog: {
          name: 'vcenterlog',
          label: 'vCenter 로그',
          active: false,
        },
        hypervlog: {
          name: 'hypervlog',
          label: 'HYPER-V 로그',
          active: false,
        },
        rhevlog: {
          name: 'rhevlog',
          label: 'RHEV 로그',
          active: false,
        },
        virtualmap: {
          name: 'virtualmap',
          label: '가상화맵',
          active: false,
        },
      },
    };
  },
  computed: {
    showVcenterLogTab() {
      return this.selectedNode.hypervisorType === 'VMWARE';
    },
    showHypervLogTab() {
      return this.selectedNode.hypervisorType === 'HYPERV';
    },
    showRhevLogTab() {
      return this.selectedNode.hypervisorType === 'RHEV';
    },
    showVirtualMapTab() {
      return !isNil(this.selectedNode.objtypeId);
    },
    ...mapGetters(['selectedNode']),
  },
  methods: {
    /**
     * 사용할 수 없는 탭인지 확인한다.
     * @author Ju
     * @param  {[type]}  tabName [description]
     */
    isDisabledTab(tabName) {
      return (!this.showVcenterLogTab && tabName === 'vcenterlog')
      || (!this.showHyperLogTab && tabName === 'hypervlog')
      || (!this.showRhevLogTab && tabName === 'rhevlog')
      || (!this.showVirtualMapTab && tabName === 'virtualmap');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/index.vue